// Shared CMS field-badge visual constants — the single source of truth (TS side)
// for the revert-button and "edited by assistant" AI-badge markup that
// editor-ai-review.ts hand-builds client-side (_ensureRevertButton /
// _showAiBadge) for fields whose initial server render omitted the control.
//
// These mirror the Go-side constants in
// templates/components/cms_field_badge_markup.go (rendered by
// cms_revert_button.templ's cmsRevertButton / cmsAiBadge). Go (templ) and
// TypeScript can't share one physical constant without codegen, so the class
// strings and SVG path data are single-sourced per runtime — change the visual
// in BOTH files, keeping the rendered markup byte-identical.

// Revert control (Heroicons "arrow-uturn-left").
export const CMS_REVERT_BTN_CLASS =
  "absolute top-0 right-0 z-10 inline-flex items-center p-1 text-base-content/40 hover:text-primary transition-colors";
export const CMS_REVERT_ICON_PATH = "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3";
export const CMS_REVERT_BTN_SVG = `<svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="${CMS_REVERT_ICON_PATH}"></path></svg>`;

// "Edited by assistant — review" badge (Heroicons "sparkles").
export const CMS_AI_BADGE_CLASS =
  "absolute top-0 right-6 z-10 inline-flex items-center p-1 text-secondary/70";
export const CMS_AI_BADGE_ICON_PATH =
  "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z";
export const CMS_AI_BADGE_SVG = `<svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="${CMS_AI_BADGE_ICON_PATH}"></path></svg>`;
